/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPaginatedProjectFileListDto } from '../../models/backend-paginated-project-file-list-dto';

export interface ProjectsProjectsFilesList$Params {
  /**
   * Number of results to return per page.
   */
  limit?: number;

  /**
   * The initial index from which to return the results.
   */
  offset?: number;
  project?: number;
}

export function projectsProjectsFilesList(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsProjectsFilesList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPaginatedProjectFileListDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectsFilesList.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('project', params.project, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPaginatedProjectFileListDto>;
    }),
  );
}

projectsProjectsFilesList.PATH = '/api/projects/projects/files/';
